export default function convertToOption(value) {
  return {
    label: value,
    value,
  };
}

export function convertToEnumWithOptions(obj) {
  return Object.fromEntries(
    Object.entries(obj).map(option => [option[0], convertToOption(option[1])]),
  );
}

export const convertToOptionInScreamingSnakeCase = ([key, value]) => {
  return {
    label: value,
    value: key,
  };
};
